import {mergeRight, without, append, uniq, clone, pick, findIndex, propEq} from 'ramda'

const DEFAULT_CARD_NAMES = {
  'drift': 'Drift Attributes',
  'custom': 'Custom Attributes',
  'sourced': 'Custom Attributes',
  'SALESFORCE_CONTACT': 'Salesforce Attributes',
  'SALESFORCE_LEAD': 'Salesforce Attributes',
  'SALESFORCE_ACCOUNT': 'Salesforce Attributes'
}

const defaultState = {
  selectedProperties: [],
  driftProperties: [],
  customProperties: [],
  archivedProperties: [],
  sourcedProperties: [],
  salesforceProperties: [],
  newConfigProperties: []
}

const newConfigCreator = (currentState, property) => {
  const clonedState = clone(currentState)
  const clonedPropertyWithId = pick(['name', 'displayName', 'id', 'type', 'source'], property)
  const clonedPropertyWithoutId = pick(['name', 'displayName', 'type', 'source'], property)
  const isAdding = property.isSelected
  const clonedProperty = isAdding ? clonedPropertyWithoutId : clonedPropertyWithId
  const propertyType = property.attributeType



  const indexOfContainingCard = findIndex(propEq('cardName', DEFAULT_CARD_NAMES[propertyType]), currentState)
  const cardBeingModified = clonedState[indexOfContainingCard]
  const newDisplayIndex = cardBeingModified.attributes.length - 1

  // following are hardcoded until we expand the feature set to modify them
  clonedProperty.enabled = true
  if (!clonedProperty.source) {
    clonedProperty.source = "LEGACY"
  }
  clonedProperty.displayIndex = newDisplayIndex

  if (isAdding) {
    cardBeingModified.attributes = append(clonedProperty, cardBeingModified.attributes)
  } else {

    let removeThisAttribute
    if (!!property.source && property.source.includes('SALESFORCE')){
      removeThisAttribute = cardBeingModified.attributes.find(attribute => attribute.displayName === clonedProperty.displayName)
    } else {
      removeThisAttribute = cardBeingModified.attributes.find(attribute => attribute.name === clonedProperty.name)
    }
    cardBeingModified.attributes = without([removeThisAttribute], cardBeingModified.attributes)
  }

  return clonedState
}

const settings = (state = defaultState, action) => {
  switch (action.type) {
    case 'RECEIVE_DRIFT_PROPERTIES':
      return mergeRight(state, {
        driftProperties: action.properties
      })

    case 'RECEIVE_CUSTOM_PROPERTIES':
      return mergeRight(state, {
        customProperties: action.properties
      })

    case 'RECEIVE_ARCHIVED_PROPERTIES':
      return mergeRight(state, {
        archivedProperties: action.properties
      })

    case 'RECEIVE_SALEFORCE_PROPERTIES':
      return mergeRight(state, {
        salesforceProperties: action.properties
      })

    case 'UPDATE_PROPERTY':
      let propertyType = action.payload.property.attributeType
      propertyType = propertyType === "SALESFORCE_CONTACT" || propertyType === "SALESFORCE_LEAD" || propertyType === "SALESFORCE_ACCOUNT" ? "salesforce" : propertyType
      const property = `${propertyType}Properties`
      return mergeRight(
        state, {
          [property]: [
            ...state[property].slice(0, action.payload.index),
            action.payload.property,
            ...state[property].slice(action.payload.index + 1)
          ],
          newConfigProperties: newConfigCreator(state.newConfigProperties, action.payload.property)
        }
      )

    case 'UPDATE_SOURCED_PROPERTY':
      return mergeRight(state, {
        sourcedProperties: [
            ...state.sourcedProperties.slice(0, action.payload.index),
            action.payload.property,
            ...state.sourcedProperties.slice(action.payload.index + 1)
          ],
          selectedProperties:
            action.payload.property.isSelected ?
            [ ...state.selectedProperties, action.payload.property.displayName] :
            state.selectedProperties.filter(sP => sP !== action.payload.property.displayName)
        })

    case 'SELECT_PROPERTY':
      if (Array.isArray(action.selectedProp)) {
        return mergeRight(state, {
          selectedProperties: uniq(action.selectedProp)
        })
      } else {
        return mergeRight(state, {
          selectedProperties: uniq(append(action.selectedProp, state.selectedProperties))
        })
      }
    case 'DESELECT_PROPERTY':
      const removed = Array.isArray(action.deselectedProp) ? action.deselectedProp : [action.deselectedProp]
      return mergeRight(state, {
        selectedProperties: without(removed, state.selectedProperties)
      })

    case 'ARCHIVE_PROPERTY':
      let prevProp = clone(action.archivedProp)
      prevProp.status = action.archivedProp.status === "ENABLED" ? "HIDDEN" : "ENABLED"
      if (action.archivedProp.status === "HIDDEN") {
        console.log(uniq(append(action.archivedProp, state.archivedProperties)))
        return mergeRight(state, {
          archivedProperties: uniq(append(action.archivedProp, state.archivedProperties)),
          customProperties: without([ prevProp ], state.customProperties)
        })
      } else {
        return mergeRight(state, {
          archivedProperties: without([ prevProp ], state.archivedProperties),
          customProperties: uniq(append(action.archivedProp, state.customProperties))
        })
      }

    case 'RECEIVE_SOURCED_PROPERTIES':
      return mergeRight(state, {
        sourcedProperties: action.properties
      })

    case 'RECEIVE_NEW_SIDEBAR_CONFIG':
      return mergeRight(state, {
        newConfigProperties: action.config
      })

    default:
      return state
  }
}

export default settings
